import React from "react";

import styles from "./NewsletterPromoSuccess.css";

export default class NewsletterPromoSuccess extends React.Component {
  constructor() {
    super();

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.focus();
  }

  render() {
    return (
      <div className={styles.root} ref={this.ref} tabIndex="-1">
        <h4 className={styles.title}>Thanks for subscribing</h4>
        <p className={styles.content}>
          For more of what matters, check out our{" "}
          <a href="http://link.axios.com/join/signup-all">other newsletters</a>.
        </p>
      </div>
    );
  }
}
